var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClaveunica(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 13.0696C12.9837 13.0696 13.3758 13.4617 13.3758 13.9454C13.3758 14.4291 12.9837 14.8213 12.5 14.8213C12.0163 14.8213 11.6242 14.4291 11.6242 13.9454C11.6242 13.4617 12.0163 13.0696 12.5 13.0696Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6313 0.874726C11.6313 0.391628 12.0229 0 12.506 0H15.9587C16.4418 0 16.8335 0.391628 16.8335 0.874726C16.8335 1.35782 16.4418 1.74945 15.9587 1.74945H13.3807V8.53096C15.9912 8.9523 17.9847 11.216 17.9847 13.9454C17.9847 16.9745 15.5291 19.4301 12.5 19.4301C9.47087 19.4301 7.01526 16.9745 7.01526 13.9454C7.01526 11.2119 9.01494 8.9454 11.6313 8.52904V0.874726ZM8.76472 13.9454C8.76472 11.8824 10.4371 10.2101 12.5 10.2101C14.563 10.2101 16.2353 11.8824 16.2353 13.9454C16.2353 16.0083 14.563 17.6807 12.5 17.6807C10.4371 17.6807 8.76472 16.0083 8.76472 13.9454Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7509 4.83143C16.3132 4.62697 15.7926 4.81604 15.5882 5.25374C15.3837 5.69143 15.5728 6.21201 16.0105 6.41647C18.8444 7.7403 20.805 10.6148 20.805 13.9455C20.805 18.5323 17.0867 22.2505 12.5 22.2505C7.91327 22.2505 4.19498 18.5323 4.19498 13.9455C4.19498 10.6256 6.14293 7.75894 8.96206 6.42938C9.399 6.2233 9.58616 5.70204 9.38009 5.2651C9.17402 4.82815 8.65275 4.641 8.21581 4.84707C4.80728 6.45461 2.44553 9.92337 2.44553 13.9455C2.44553 19.4985 6.94707 24 12.5 24C18.0529 24 22.5545 19.4985 22.5545 13.9455C22.5545 9.91029 20.1774 6.43206 16.7509 4.83143Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaveunica);
export default __webpack_public_path__ + "static/media/claveunica.45ca589c7494b1803a0678c39102413e.svg";
export { ForwardRef as ReactComponent };